import { Typography } from "@mui/material";
import * as React from "react";
import { TreeCheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/TreeCheckboxDropdown";
import { Base } from "ui/Scripts/source/framework/base";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { FormFieldMargin } from "./TaskDynamicForm.styles";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { DisabledInputClickEnabler } from "./DisabledInputClickEnabler";
import { getFormFieldTitle, getFormFieldTitleColor } from "./TaskDynamicFormFieldUtils";

export interface ITaskDynamicFormTreeStringArrayProp {
    isReadOnly: boolean;
    colIsReadOnly: boolean;
    showFieldName: boolean;
    showFieldNameColor: string;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormTreeStringArray extends React.Component<ITaskDynamicFormTreeStringArrayProp, {}> {
    handleChange = (selectedIds: string[]) => {
        const newValue = new TaskDataRowCol(this.props.taskDataRowCol);
        newValue.valueStr = JSON.stringify(selectedIds);
        this.props.onChange(newValue);
    };
    
    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        const options = !Base.isNullOrUndefined(typeCol.idNodeOptions) && typeCol.idNodeOptions.length > 0
            ? typeCol.idNodeOptions
            : null;
        const valueIds: string[] = dataCol?.valueStr ? JSON.parse(dataCol?.valueStr) : [];
        return (
            <FormField title={getFormFieldTitle(typeCol, props.showFieldName)} titleColor={getFormFieldTitleColor(props.showFieldName, props.showFieldNameColor)} required={typeCol.required && !props.isReadOnly} margin={FormFieldMargin}>
                {props.isReadOnly &&
                    <Typography>{valueIds.length > 0 ? options.filter(i => valueIds.indexOf(i.id) > -1).map(i => i.title).join(", ") : ""}</Typography>
                }
                {!props.isReadOnly &&
                    <DisabledInputClickEnabler
                        input={<TreeCheckboxDropdown
                            disabled={props.colIsReadOnly}
                            selectedIds={valueIds}
                            required={true}
                            toggleAllId={""}
                            hideParentsInSelection={true}
                            selectSubSectionValuesByTitle={typeCol.selectOptionsSubSectionValuesByTitle}
                            values={options}
                            onChange={this.handleChange}
                        />}
                        disabled={props.colIsReadOnly}
                    />
                }
            </FormField>
        );
    }
}